var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "attach_svg2__a",
    x1: 0,
    x2: 200,
    y1: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M52.2 190.3C23.4 190.3 0 167 0 138.1c0-13.9 5.5-27.2 15.3-37l77.1-77c2.7-2.7 7-2.7 9.6 0 2.7 2.7 2.7 7 0 9.6l-77.1 77.1c-15.4 14.7-16 39.1-1.4 54.6 14.7 15.4 39.1 16 54.6 1.4.5-.4.9-.9 1.4-1.4L179 65.9c9.6-9.9 9.3-25.7-.6-35.3-9.7-9.4-25.1-9.4-34.8 0l-80.1 80.2c-4.4 4.4-4.4 11.6 0 16.1 4.4 4.4 11.6 4.4 16.1 0L131 75.5c2.6-2.7 6.9-2.8 9.6-.2s2.8 6.9.2 9.6l-.2.2-51.4 51.4c-9.8 9.8-25.6 9.8-35.3 0-9.8-9.8-9.8-25.6 0-35.3L134.1 21c15.1-15.1 39.5-15.1 54.6 0s15.1 39.5 0 54.6l-99.5 99.5c-9.8 9.8-23.1 15.3-36.9 15.3Z",
    "data-name": "Layer 2",
    style: {
      fill: "url(#attach_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgAttach;